import { defineMessages } from '../define';

export const audit = defineMessages({
  en: {
    'audit.title': 'Audit log',
    'audit.description':
      'Every state-changing call that succeeded, with the request body stored minus passwords and tokens.',
    'audit.searchPlaceholder': 'Search actions and targets…',

    'audit.forbidden.title': 'Administrators only',
    'audit.forbidden.description':
      "The audit trail records who did what, including actions taken against other people's data, so it is limited to admins and the owner.",

    'audit.actionLabel': 'Filter by action',
    'audit.action.all': 'All actions',
    'audit.action.auth': 'Authentication',
    'audit.action.session': 'Sessions',
    'audit.action.message': 'Messages',
    'audit.action.webhook': 'Webhooks',
    'audit.action.keyword': 'Keywords',
    'audit.action.notification': 'Notifications',
    'audit.action.apiKey': 'API keys',
    'audit.action.user': 'Users',
    'audit.action.settings': 'Settings',
    'audit.action.logs': 'Log maintenance',

    'audit.actorLabel': 'Filter by actor',
    'audit.actor.all': 'All actors',
    'audit.fromLabel': 'From date',
    'audit.toLabel': 'To date',

    'audit.column.time': 'Time',
    'audit.column.actor': 'Actor',
    'audit.column.action': 'Action',
    'audit.column.target': 'Target',
    'audit.column.ip': 'IP',

    'audit.empty.title': 'No matching entries',
    'audit.empty.description':
      'Nothing was recorded in this window. Widen the date range or clear the filters.',

    'audit.detail.ip': 'IP address',
    'audit.detail.userAgent': 'User agent',
    'audit.detail.metadata': 'Metadata',
    'audit.detail.noMetadata': 'Nothing recorded.',
  },
  th: {
    'audit.title': 'บันทึกการตรวจสอบ',
    'audit.description':
      'ทุกคำสั่งที่เปลี่ยนแปลงข้อมูลและทำสำเร็จ พร้อมเนื้อหาคำขอที่เก็บไว้โดยตัดรหัสผ่านและโทเค็นออก',
    'audit.searchPlaceholder': 'ค้นหาการกระทำและเป้าหมาย…',

    'audit.forbidden.title': 'เฉพาะผู้ดูแลระบบเท่านั้น',
    'audit.forbidden.description':
      'บันทึกการตรวจสอบเก็บว่าใครทำอะไรไว้ รวมถึงการกระทำต่อข้อมูลของผู้อื่น จึงเปิดให้เฉพาะผู้ดูแลระบบและเจ้าของบัญชีเท่านั้น',

    'audit.actionLabel': 'กรองตามการกระทำ',
    'audit.action.all': 'ทุกการกระทำ',
    'audit.action.auth': 'การยืนยันตัวตน',
    'audit.action.session': 'เซสชัน',
    'audit.action.message': 'ข้อความ',
    'audit.action.webhook': 'Webhook',
    'audit.action.keyword': 'คำสำคัญ',
    'audit.action.notification': 'การแจ้งเตือน',
    'audit.action.apiKey': 'คีย์ API',
    'audit.action.user': 'ผู้ใช้',
    'audit.action.settings': 'การตั้งค่า',
    'audit.action.logs': 'การดูแลบันทึกระบบ',

    'audit.actorLabel': 'กรองตามผู้กระทำ',
    'audit.actor.all': 'ทุกผู้กระทำ',
    'audit.fromLabel': 'ตั้งแต่วันที่',
    'audit.toLabel': 'ถึงวันที่',

    'audit.column.time': 'เวลา',
    'audit.column.actor': 'ผู้กระทำ',
    'audit.column.action': 'การกระทำ',
    'audit.column.target': 'เป้าหมาย',
    'audit.column.ip': 'IP',

    'audit.empty.title': 'ไม่พบรายการที่ตรงกัน',
    'audit.empty.description': 'ไม่มีการบันทึกในช่วงเวลานี้ ลองขยายช่วงวันที่หรือล้างตัวกรอง',

    'audit.detail.ip': 'ที่อยู่ IP',
    'audit.detail.userAgent': 'User agent',
    'audit.detail.metadata': 'ข้อมูลกำกับ',
    'audit.detail.noMetadata': 'ไม่มีข้อมูลที่บันทึกไว้',
  },
});
